import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { CheckoutScheduledReplenishmentComponentsModule } from '@spartacus/checkout/scheduled-replenishment/components';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutScheduledReplenishmentModule = /*#__PURE__*/(() => {
  class CheckoutScheduledReplenishmentModule {
    static {
      this.ɵfac = function CheckoutScheduledReplenishmentModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutScheduledReplenishmentModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutScheduledReplenishmentModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CheckoutScheduledReplenishmentComponentsModule]
      });
    }
  }
  return CheckoutScheduledReplenishmentModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/*
 * Public API Surface of checkout
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CheckoutScheduledReplenishmentModule };
